import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { POTypeEnum, SupplierTypeEnum } from "@gtpl/shared-models/common-models";
import { Farm } from "./farms.entity";
import { ApiProperty } from "@nestjs/swagger";
import { Supplier } from "./supplier.entity";

// import { VendorsPriceList } from "../vendors-price-list/entities/vendor-price-list.entity";

@Entity('suppliers_log')
export class SupplierLog {

    @PrimaryGeneratedColumn("increment", { name: 'id' })
    id: number;

    @Column("char", {
        nullable: false,
        length: 50,
        name: "code"
    })
    @Index({ unique: false })
    supplierCode: string;

    @Column("varchar", {
        nullable: false,
        length: 50,
        name: "name"
    })
    supplierName: string;

    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "gst_number"
    })
    gstNumber: string;
  @Column("varchar", {
        nullable: true,
        length: 50,
        name: "contact_person"
    })
    contactPerson: string;

    @Column("varchar", {
        nullable: true,
        length: 70,
        name: "city"
    })
    city: string;

    @Column("varchar", {
        nullable: true,
        length: 100,
        name: "state"
    })
    state: string;

    @Column("varchar", {
        nullable: true,
        length: 70,
        name: "district"
    })
    district: string;
    @Column("varchar", {
        nullable: true,
        length: 20,
        name: "contact_number"
    })
    contactNumber: string;
    @Column("varchar", {
        nullable: true,
        name: "created_user"
    })
    createdUser: string | null;

    @Column({
        name: "effective_from",
        type: 'datetime'
      })
      effectiveFrom: Date;
    @ManyToOne(type => Supplier, e => e.supplierLogInfo, { nullable: false, })
    @JoinColumn({ name: "ref_id" })
    supplierInfo: Supplier;

}
